import React, { useState } from 'react';
import { Message, Icon } from 'semantic-ui-react';

const ClosableWarning = ({ children }: any) => {
  const [isHidden, setIsHidden] = useState(false);

  if (isHidden) {
    return null;
  }

  return (
    <Message warning icon onDismiss={() => setIsHidden(true)}>
      <Icon name="warning sign" size="large" />
      <Message.Content>{children}</Message.Content>
    </Message>
  );
};

export default ClosableWarning;
